module.exports = __webpack_public_path__ + "static/seo-34bc6f59cf8851bc3955d95a0f197f03.svg";